export var STICKIES = ['10rem'];
export var CENTERED_INPUT_PROPS = { style: { textAlign: 'center' } };
